import { Navigate } from "react-router"
import { useAuth } from "@/lib/auth/auth-context"
import { OnboardingProvider, useOnboarding } from "@/lib/onboarding/onboarding-context"
import { OnboardingShell } from "@/components/onboarding/onboarding-shell"
import { PersonalInfoStep } from "@/components/onboarding/personal-info-step"
import { CompanyIdentityStep } from "@/components/onboarding/company-identity-step"
import { CompanyLocationStep } from "@/components/onboarding/company-location-step"
import { InviteMembersStep } from "@/components/onboarding/invite-members-step"
import { ExtraStep } from "@/components/onboarding/extra-step"
import { GroupBodyshopsStep } from "@/components/onboarding/group-bodyshops-step"

function StepRouter() {
  const { step } = useOnboarding()
  switch (step) {
    case "personal":
      return <PersonalInfoStep />
    case "company":
      return <CompanyIdentityStep />
    case "location":
      return <CompanyLocationStep />
    case "invite":
      return <InviteMembersStep />
    case "extra":
      return <ExtraStep />
    case "bodyshops":
      return <GroupBodyshopsStep />
  }
}

export default function OnboardingPage() {
  const { user, isLoading, hasTeams } = useAuth()

  // Gate the page itself on auth + already-onboarded state. Without this
  // gate, a signed-in user with teams who navigates to /onboarding (e.g.
  // refresh on the URL, browser-back into /onboarding after finishing) gets
  // a fresh OnboardingProvider — and submitting step 2b would create a
  // *second* group/dealership/bodyshop team for them, which is exactly the
  // duplicate-team bug surfaced as "I see two groups in my switcher."
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-zinc-900 border-t-transparent mx-auto mb-4" />
          <p className="text-zinc-400">Loading...</p>
        </div>
      </div>
    )
  }
  if (!user) return <Navigate to="/login" replace />
  if (hasTeams) return <Navigate to="/dashboard" replace />

  return (
    <OnboardingProvider>
      <OnboardingShell>
        <StepRouter />
      </OnboardingShell>
    </OnboardingProvider>
  )
}
